import styled from "styled-components";
export const FleetWrapper = styled.div`
  background-color: #fff;
  width: 100%;
`;
